import { createTheme } from "@mui/material/styles";
import { breakpoints, fontFamily, palette } from "./tokens";

// MUI 컴포넌트(Snackbar, Menu, Switch 등)가 원보카 토큰과 같은 색 · 글꼴을 쓰도록 맞춘다.
const muiTheme = createTheme({
  palette: {
    primary: { main: palette.primary, dark: palette.primaryHover },
    error: { main: palette.danger },
    success: { main: palette.success },
    warning: { main: palette.warning },
  },
  typography: {
    fontFamily,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: breakpoints.tablet,
      md: breakpoints.tablet,
      lg: breakpoints.desktop,
      xl: 1536,
    },
  },
});

export default muiTheme;
